import React from 'react';
import styles from '../../styles/CreativeEditor.module.css';

export interface NavSection {
  id: string;
  title: string;
}

interface FormNavSidebarProps {
  sections: NavSection[];
  activeSectionId: string | null;
  onSectionClick: (sectionId: string) => void;
}

const FormNavSidebar: React.FC<FormNavSidebarProps> = ({
  sections,
  activeSectionId,
  onSectionClick,
}) => {
  return (
    <nav className={styles.formNavSidebar} aria-label="Form sections">
      <ul className={styles.formNavList}>
        {sections.map((section) => (
          <li key={section.id}>
            <button
              type="button"
              className={`${styles.formNavItem} ${section.id === activeSectionId ? styles.formNavItemActive : ''}`}
              onClick={() => onSectionClick(section.id)}
            >
              {section.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FormNavSidebar;
